/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Determines behavior when a hook action fails.
 */
export enum FailurePolicyType {
  FailurePolicyBlock = 'Block',
  FailurePolicyContinue = 'Continue',
}
